import React, { Component } from 'react';
import FetchCall, { partnerApi, commonAPI } from './../../../../API/FetchCall';
import { MOBILE_REGEX, URL_REGEX } from '../../../../constant.js';
import SimpleReactValidator from 'simple-react-validator';
import { Multiselect } from 'multiselect-react-dropdown';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import {
  Collapse,
  CardBody,
  Card,
  CardHeader
} from 'reactstrap';
class Keyinfo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user_data: localStorage.getItem('user_data') ? JSON.parse(localStorage.getItem('user_data')) : [],
      authentication: localStorage.getItem('authentication') ? JSON.parse(localStorage.getItem('authentication')) : false,
      user_type: 0,
      main_access: '',
      main_id: '',
      dropdown: [],
      access: [],
      board_of_education: [], //drop
      type_institute: [], //drop
      school_type: [], //drop
      education_system: [], //drop
      playarea_type: [], //drop
      camp_type: [], //drop
      grade_from: [], //drop
      grade_to: [], //drop
      time_from: [], //drop
      time_to: [], //drop
      time_from_category: [], //drop
      time_to_category: [], //drop
      incharge_name: '',
      teacher_count: '',
      established_year: '',
      instruction_language: '',
      minimum_age: '',
      has_scholarship: 0,
      scholarship_desc: '',
      has_trail: 0,
      trail_desc: '',
      facilities: [], //drop
      learning_option: [], //drop
      learning_type: [], //drop
      class_frequency: [], //drop
      noclass: '',
      student_ratio: '',
      contact_person: '',
      facebook_name: '',
      twitter_name: '',
      when: '',
      where: '',
      registration_info: '',
      hall_capacity: '',
      dinning_hall_capacity: '',
      car_parking: '',
      two_parking: '',
      operating_hrs: '',
      food: '',
      payment_type: [], //drop
      cons_service: [], //drop
      class_range: [],
      designation: '',
      cons_drop: false,
      website: '',
      website_keyword: '',
      active_status: 0,
      btnDisabled: true,
      collapse: 0,
      page_data: [],
      keywordsArr: [],
      checking: false
    }
    this.validator = new SimpleReactValidator({
      validators: {
        checkMobile: MOBILE_REGEX,
        checkUrl: URL_REGEX
      }
    });
    this.toggle = this.toggle.bind(this);
    this.getDropData(); this.getKeyInfo();
  }
  componentDidUpdate() {
    window.jQuery('.selectpicker').selectpicker('refresh');
  }
  componentDidMount() {

  }
  async getKeyInfo() {
    const { user_type, login_id, set_id } = this.state.user_data;
    let insdata = JSON.stringify({
      user_type: user_type,
      login_id: login_id,
      sid: set_id,
      url: 'getKeyInfoNew'
    });
    let THIS = this;
    await partnerApi(insdata).then((response) => {
      if (response.status === 1) {
        this.setState({
          btnDisabled: false,
          checking: true,
          active_status: response.result.active_status,
          page_data: response.result.master_data,
        })
        setTimeout(function () {
          THIS.setState({
            checking: false
          })
        }, 500)
      }
    })
  }
  getKeywords = () => {
    commonAPI(JSON.stringify({ url: 'get_site_keywords' })).then((res) => {
      if (res.status === 1) {
        this.setState({
          keywordsArr: res.results
        })
      }
    })
  }
  handleChange = (e, index) => {
    const propName = e.target.name;
    const propValue = e.target.value;
    let page_data = this.state.page_data;
    page_data[index][propName] = propValue;
    this.setState({ page_data });
  };
  toggle(event) {
    this.setState({
      collapse: this.state.collapse === Number(event) ? -1 : Number(event)
    });
  }
  handleSelectGradeFrom = (e, index) => {
    let grade_from = parseInt(e.target.value);
    let page_data = this.state.page_data;
    let grade_to = parseInt(page_data[index].grade_to);
    if ((grade_from >= grade_to)) {
      page_data[index]['grade_from'] = '';
       
      NotificationManager.error('Grade to should be greater than grade from!');

      return false;
    } else {
      page_data[index]['grade_from'] = grade_from;
    }
    this.setState({ page_data });
  };
  handleSelectGradeto = (e, index) => {
    let page_data = this.state.page_data;
    let grade_from = parseInt(page_data[index].grade_from);
    let grade_to = parseInt(e.target.value);
    if ((grade_to <= grade_from)) {
       
      page_data[index]['grade_to'] = '';
       
      NotificationManager.error('Grade to should be greater than grade from!');
    } else {
      page_data[index]['grade_to'] = grade_to;
    }
    this.setState({ page_data });
  };
  handleSelect = (e, i) => {
    const propName = e.target.name;
    const value = [...e.target.selectedOptions].map((item) => item.value);
    let page_data = this.state.page_data;
    page_data[i][propName] = value;
    this.setState({ page_data });
  };
  render() {
    const { access, dropdown, cons_drop, user_type, collapse, page_data } = this.state;
    this.validator.purgeFields();
    return (
      <React.Fragment>

<div class="category_block">

<div class="titleline">
  <h4>Key Information</h4>
</div>

        <div className="eachblockgap">
         
            {page_data.map((item, index) => {
              const ageLable = item.cid == 6 ? 'Teaching For Grades' : 'Min Age of Admission';
              const learntypeLable = (item.cid == 6 || item.cid == 8) ? 'Teacher Student Ratio' : 'Learning Option (Choose applicable)';
              const learntypeLableOther = (item.cid == 6 || item.cid == 8) ? 'Teacher Student Ratio' : 'Learning Option';
              let keywords = item.website_keyword;
              return (

                <div>
                 <form onSubmit={(e) => this.submitForm(e, index)}>   
                <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }} key={index}>
                  <CardHeader onClick={() => this.toggle(index)} data-event={index} className='custom-card-heading'>
                    <b>{item.category_name}</b>
                    <small>{item.sub_category_name ? ' - ' + item.sub_category_name : ''}</small>
                    {collapse !== index ? (
                      <span className='pull-right'>
                        <i class="fa fa-plus" aria-hidden="true"></i>
                      </span>
                    ) : (
                      <span className='pull-right'>
                        <i class="fa fa-minus" aria-hidden="true"></i>
                      </span>
                    )}
                  </CardHeader>
                  <Collapse isOpen={collapse === index}>
                    <CardBody className='panel-body'>

                      <h3 className="page-header">{item.organisation_name} <span style={{fontSize:"10px"}}><b>{item.set_id==3?"Branch":""}</b></span></h3>
                      <p className='mar-btm'>{item.address}</p>

                      <div class="box-shadow-custom">
                        {item.is_active == 0 ?
                          (
                            <div className='row mar-btm'>
                              <div class="form-group col-md-12">
                                <h3 className='text-center'>Upgrade/Renewal to update the Data</h3>
                              </div>
                            </div>
                          ) :
                          (
                            <div className='row'>
                              {(item.cid == 6) &&
                                (
                                  <div class="form-group col-md-4">
                                    <label>Person Incharge</label>
                                    <input name='incharge_name' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.incharge_name} />
                                    {this.validator.message('Person Incharge', item.incharge_name, 'alpha_space', { className: 'text-danger error-msg' })}
                                  </div>
                                )
                              }
                              {(item.cid == 4 && item.fourthcat_list.length > 0) &&
                                (
                                  <div class="form-group col-md-4">
                                    <label> Sub Category <span class="astrick">*</span></label>
                                    <select
                                      className='form-control selectpicker'
                                      multiple
                                      name='subtypes'
                                      value={item.subtypes}
                                      title='Select Sub Category'
                                      onChange={(e) => this.handleSelect(e, index)}>
                                      {item.fourthcat_list && item.fourthcat_list.map((val, i) => {
                                        return (
                                          <option value={val.category_id} key={i} >
                                            {val.category_name} ({val.parent})
                                          </option>
                                        )
                                      })}
                                    </select>
                                    {this.validator.message('Sub Category', item.subtypes, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                )
                              }
                              {(item.cid == 6 || item.cid == 1) &&
                                (
                                  <div class="form-group col-md-4">
                                    <label> Board of Education <span class="astrick">*</span></label>
                                    <select
                                      className='form-control selectpicker'
                                      multiple
                                      name='board_of_education'
                                      value={item.board_of_education}
                                      title='Select Board Of Education'
                                      onChange={(e) => this.handleSelect(e, index)}>
                                      {dropdown.board_of_education && dropdown.board_of_education.map((val, i) => {
                                        return (
                                          <option value={val.id} key={i} >
                                            {val.name}
                                          </option>
                                        )
                                      })}
                                    </select>
                                    {this.validator.message('Board Of Education', item.board_of_education, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                )
                              }

                              {item.cid == 1 &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> Campus Type <span class="astrick">*</span></label>
                                      <select
                                        className='form-control selectpicker'
                                        multiple
                                        name='type_institute'
                                        value={item.type_institute}
                                        title='Select Campus Type'
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        {dropdown.type_institute && dropdown.type_institute.map((val, i) => {
                                          return (
                                            <option value={val.id} key={i} >
                                              {val.name}
                                            </option>
                                          )
                                        })}
                                      </select>
                                      {this.validator.message('Campus Type', item.type_institute, 'required', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label> School Type <span class="astrick">*</span></label>
                                      <select
                                        className='form-control selectpicker'
                                        name='school_type'
                                        value={item.school_type}
                                        title='Select School Type '
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        {dropdown.school_type && dropdown.school_type.map((val, i) => {
                                          return (
                                            <option value={val.id} key={i} >
                                              {val.type_name}
                                            </option>
                                          )
                                        })}
                                      </select>
                                      {this.validator.message('School Type', item.school_type, 'required', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label> Classfication</label>
                                      <select
                                        className='form-control selectpicker'
                                        name='education_system'
                                        value={item.education_system}
                                        title='Select Classfication'
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        {dropdown.education_system && dropdown.education_system.map((val, i) => {
                                          return (
                                            <option value={val.id} key={i} >
                                              {val.name}
                                            </option>
                                          )
                                        })}
                                      </select>
                                      {/* {this.validator.message('Classfication', this.state.education_system, 'required', { className: 'text-danger error-msg' })} */}
                                    </div>
                                    <div className="form-group col-md-4 input-group-cus to-separate">
                                      <div>
                                        <label>Grades <span class="astrick">*</span></label>
                                        <div className="custom-select-drop dropdown">
                                          <select
                                            className='form-control selectpicker'
                                            name='grade_from'
                                            value={item.grade_from}
                                            title='Grade'
                                            onChange={(e) => this.handleSelectGradeFrom(e, index)}>
                                            {dropdown.grades && dropdown.grades.map((val, i) => {
                                              return (
                                                <option value={val.id} key={i} >
                                                  {val.name}
                                                </option>
                                              )
                                            })}
                                          </select>
                                        </div>
                                        {this.validator.message('Grade', item.grade_from, 'required', { className: 'text-danger error-msg' })}
                                      </div>
                                      <span className="to">to</span>
                                      <div>
                                        <label>&nbsp;</label>

                                        <div className="custom-select-drop dropdown">
                                          <select
                                            className='form-control selectpicker'
                                            name='grade_to'
                                            value={item.grade_to}
                                            title='Grade'
                                            onChange={(e) => this.handleSelectGradeto(e, index)}>
                                            {dropdown.grades && dropdown.grades.map((val, i) => {
                                              return (
                                                <option value={val.id} key={i} >
                                                  {val.name}
                                                </option>
                                              )
                                            })}
                                          </select>
                                        </div>
                                        {this.validator.message('Grade', item.grade_to, 'required', { className: 'text-danger error-msg' })}
                                      </div>
                                    </div>
                                  </React.Fragment>
                                )
                              }
                              {(item.cid == 3) &&
                                (
                                  <div class="form-group col-md-4">
                                    <label> Catering To Age Group <span class="astrick">*</span></label>
                                    <select
                                      className='form-control selectpicker'
                                      multiple
                                      name='playarea_type'
                                      value={item.playarea_type}
                                      title='Select Type'
                                      onChange={(e) => this.handleSelect(e, index)}>
                                      {dropdown.playarea_type && dropdown.playarea_type.map((val, i) => {
                                        return (
                                          <option value={val.id} key={i} >
                                            {val.name}
                                          </option>
                                        )
                                      })}
                                    </select>
                                    {this.validator.message('Type', item.playarea_type, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                )
                              }

                              {(item.cid == 121 && item.cons_drop == true) &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> Designation <span class="astrick">*</span></label>
                                      <input name='designation' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.designation} />
                                      {this.validator.message('Designation', item.designation, 'required|alpha_space', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label> Service <span class="astrick">*</span></label>
                                      <select
                                        className='form-control selectpicker'
                                        multiple
                                        name='cons_service'
                                        value={item.cons_service}
                                        title='Select Type'
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        {dropdown.cons_service && dropdown.cons_service.map((val, i) => {
                                          return (
                                            <option value={val.id} key={i} >
                                              {val.service}
                                            </option>
                                          )
                                        })}
                                      </select>
                                      {this.validator.message('Service', item.cons_service, 'required', { className: 'text-danger error-msg' })}
                                    </div>
                                  </React.Fragment>
                                )
                              }
                              {(item.cid == 8) &&
                                (
                                  <div class="form-group col-md-4">
                                    <label> Type <span class="astrick">*</span></label>
                                    <select
                                      className='form-control selectpicker'
                                      multiple
                                      name='camp_type'
                                      value={item.camp_type}
                                      title='Select Type'
                                      onChange={(e) => this.handleSelect(e, index)}>
                                      {dropdown.camp_type && dropdown.camp_type.map((val, i) => {
                                        return (
                                          <option value={val.id} key={i} >
                                            {val.name}
                                          </option>
                                        )
                                      })}
                                    </select>
                                    {this.validator.message('Type', item.camp_type, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                )
                              }
                              {(item.cid == 1 || item.cid == 2
                                || item.cid == 3 || item.cid == 4 || item.cid == 6) &&
                                (
                                  <React.Fragment>
                                    <div className="form-group col-md-4 input-group-cus">
                                      <div>
                                        <label>From Time <span class="astrick">*</span></label>
                                        <div className="custom-select-drop dropdown">
                                          <select
                                            className='form-control selectpicker'
                                            name='time_from'
                                            value={item.time_from}
                                            title='Time'
                                            onChange={(e) => this.handleSelect(e, index)}>
                                            {dropdown.timings && dropdown.timings.map((val, i) => {
                                              return (
                                                <option value={val.id} key={i} >
                                                  {val.timing}
                                                </option>
                                              )
                                            })}
                                          </select>
                                        </div>
                                        {this.validator.message('Time', item.time_from, 'required', { className: 'text-danger error-msg' })}
                                      </div>
                                      <div>
                                        <label>&nbsp;</label>

                                        <div className="custom-select-drop dropdown">
                                          <select
                                            name="time_from_category"
                                            value={item.time_from_category}
                                            onChange={(e) => this.handleSelect(e, index)}
                                            className="form-control selectpicker"
                                            title='Select'
                                          >
                                            <option value='AM'>AM</option>
                                            <option value='PM'>PM</option>
                                          </select>
                                        </div>
                                        {this.validator.message('Type', item.time_from_category, 'required', { className: 'text-danger error-msg' })}
                                      </div>
                                    </div>
                                    <div className="form-group col-md-4 input-group-cus">
                                      <div>
                                        <label>To Time <span class="astrick">*</span></label>
                                        <div className="custom-select-drop dropdown">
                                          <select
                                            className='form-control selectpicker'
                                            name='time_to'
                                            value={item.time_to}
                                            title='Time'
                                            onChange={(e) => this.handleSelect(e, index)}>
                                            {dropdown.timings && dropdown.timings.map((val, i) => {
                                              return (
                                                <option value={val.id} key={i} >
                                                  {val.timing}
                                                </option>
                                              )
                                            })}
                                          </select>
                                        </div>
                                        {this.validator.message('Time', item.time_to, 'required', { className: 'text-danger error-msg' })}
                                      </div>
                                      <div>
                                        <label>&nbsp;</label>

                                        <div className="custom-select-drop dropdown">
                                          <select
                                            name="time_to_category"
                                            value={item.time_to_category}
                                            onChange={(e) => this.handleSelect(e, index)}
                                            className="form-control selectpicker"
                                            title='Select'
                                          >
                                            <option value='AM'>AM</option>
                                            <option value='PM' selected>PM</option>
                                          </select>
                                        </div>
                                        {this.validator.message('Type', item.time_to_category, 'required', { className: 'text-danger error-msg' })}
                                      </div>
                                    </div>
                                  </React.Fragment>
                                )
                              }
                              {(item.cid == 2 || item.cid == 3 || item.cid == 4 || item.cid == 6) && (
                                <React.Fragment>
                                  <div class="form-group col-md-4">
                                    <label>
                                      No Of Teachers
                                      {user_type != 2 && (
                                        <span class="astrick">*</span>
                                      )}
                                    </label>
                                    <input name='teacher_count' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.teacher_count} />
                                    {user_type != 2 ?
                                      (
                                        this.validator.message('No Of Teachers', item.teacher_count, 'required|alpha_num_dash_space', { className: 'text-danger error-msg' })
                                      ) :
                                      (
                                        this.validator.message('No Of Teachers', item.teacher_count, 'alpha_num_dash_space', { className: 'text-danger error-msg' })
                                      )
                                    }

                                  </div>
                                </React.Fragment>
                              )}
                              {(item.cid == 1 || item.cid == 2 || item.cid == 6 || item.cid == 7
                                || item.cid == 3 || item.cid == 4 || item.cid == 121) &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> Establishment Year <span class="astrick">*</span></label>
                                      <input name='established_year' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.established_year} />
                                      {this.validator.message('Establishment Year', item.established_year, 'required|numeric|min:4|max:4', { className: 'text-danger error-msg' })}
                                    </div>
                                  </React.Fragment>
                                )
                              }


                              {(item.cid == 1 || item.cid == 6) &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> Instruction Languages <span class="astrick">*</span></label>
                                      <input name='instruction_language' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.instruction_language} />
                                      {this.validator.message('Instruction Languages', item.instruction_language, 'required|alpha_space', { className: 'text-danger error-msg' })}
                                    </div>
                                  </React.Fragment>
                                )
                              }
                              {(item.cid == 1 || item.cid == 2 || item.cid == 4) && (
                                <React.Fragment>
                                  <div class="form-group col-md-4">
                                    <label> {ageLable} <span class="astrick">*</span></label>
                                    <input name='minimum_age' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.minimum_age} />
                                    {this.validator.message(ageLable, item.minimum_age, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                </React.Fragment>
                              )}
                              {(item.cid == 6) && (
                                <React.Fragment>
                                  <div class="form-group col-md-4">
                                    <label> {ageLable} <span class="astrick">*</span></label>
                                    <select className='form-control selectpicker' title='Select Class Range' multiple
                                      value={item.minimum_age} name="minimum_age"
                                      onChange={(e) => this.handleSelect(e, index)}>
                                      {dropdown.getTuitionCls && dropdown.getTuitionCls.map((item, i) => {
                                        return (
                                          <option value={item.id}>{item.name}</option>
                                        )
                                      })}
                                    </select>
                                    {/* <input name='minimum_age' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.minimum_age} /> */}
                                    {this.validator.message(ageLable, item.minimum_age, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                </React.Fragment>
                              )}
                              {(item.cid == 1 || item.cid == 2 || item.cid == 3) &&
                                (
                                  <div class="form-group col-md-4">
                                    <label> Amenities <span class="astrick">*</span></label>
                                    <select
                                      className='form-control selectpicker'
                                      multiple
                                      name='facilities'
                                      value={item.facilities}
                                      title='Select Amenities'
                                      onChange={(e) => this.handleSelect(e, index)}>
                                      {dropdown.facilities && dropdown.facilities.map((val, i) => {
                                        return (
                                          <option value={val.id} key={i} >
                                            {val.facility}
                                          </option>
                                        )
                                      })}
                                    </select>
                                    {this.validator.message('Amenities', item.facilities, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                )
                              }
                              {(item.cid == 1) &&
                                (
                                  <div class="form-group col-md-4">
                                    <label> Teacher Student Ratio <span class="astrick">*</span></label>
                                    <input name='student_ratio' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.student_ratio} />
                                    {this.validator.message('Teacher Student Ratio', item.student_ratio, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                )
                              }
                              {(item.cid == 4 || item.cid == 6 || item.cid == 8) &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> {learntypeLable} {!access.includes('8') && <span class="astrick">*</span>}</label>
                                      <select
                                        className='form-control selectpicker'
                                        multiple
                                        name='learning_option'
                                        value={item.learning_option}
                                        title={'Select ' + learntypeLableOther}
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        {dropdown.learning_option && dropdown.learning_option.map((val, i) => {
                                          return (
                                            <option value={val.id} key={i} >
                                              {val.name}
                                            </option>
                                          )
                                        })}
                                      </select>

                                      {!access.includes('8') && this.validator.message(learntypeLableOther, item.learning_option, 'required', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label> Learning Location <span class="astrick">*</span></label>
                                      <select
                                        className='form-control selectpicker'
                                        multiple
                                        name='learning_type'
                                        value={item.learning_type}
                                        title='Select Learning Location'
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        {dropdown.learning_type && dropdown.learning_type.map((val, i) => {
                                          return (
                                            <option value={val.id} key={i} >
                                              {val.name}
                                            </option>
                                          )
                                        })}
                                      </select>
                                      {this.validator.message('Learning Location', item.learning_type, 'required', { className: 'text-danger error-msg' })}
                                    </div>
                                  </React.Fragment>
                                )
                              }
                              {(item.cid == 4 || item.cid == 6) &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> Class Frequency <span class="astrick">*</span></label>
                                      <select
                                        multiple
                                        className='form-control selectpicker'
                                        name='class_frequency'
                                        value={item.class_frequency}
                                        title='Select Class Frequency'
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        {dropdown.class_frequency && dropdown.class_frequency.map((val, i) => {
                                          return (
                                            <option value={val.id} key={i} >
                                              {val.freq_name}
                                            </option>
                                          )
                                        })}
                                      </select>
                                      {this.validator.message('Class Frequency', item.class_frequency, 'required', { className: 'text-danger error-msg' })}
                                    </div>
                                  </React.Fragment>
                                )
                              }
                              {(item.cid == 7 || item.cid == 8) && (
                                <React.Fragment>
                                  <div class="form-group col-md-4">
                                    <label> Contact Person <span class="astrick">*</span></label>
                                    <input name='contact_person' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.contact_person} />
                                    {this.validator.message('Contact Person', item.contact_person, 'required', { className: 'text-danger error-msg' })}
                                  </div>
                                </React.Fragment>
                              )

                              }
                              {(item.cid == 4 || item.cid == 6 || item.cid == 7 || item.cid == 8
                                || item.cid == 121) && (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> No of Class/Month <span class="astrick">*</span></label>
                                      <input name='noclass' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.noclass} />
                                      {this.validator.message('No of Class', item.noclass, '', { className: 'text-danger error-msg' })}
                                    </div>
                                  </React.Fragment>
                                )

                              }
                              {/* {(access.includes('7') || access.includes('8') || access.includes('121')) &&
                (
                  <React.Fragment>
                    <div class="form-group col-md-4">
                      <label> Facebook <span class="astrick">*</span></label>
                      <input name='facebook_name' className='form-control' type='text'  onChange={(e) => this.handleChange(e, index)} value={this.state.facebook_name} />
                      {this.validator.message('Facebook', this.state.facebook_name, 'required', { className: 'text-danger error-msg' })}
                    </div>
                    <div class="form-group col-md-4">
                      <label> Twitter <span class="astrick">*</span></label>
                      <input name='twitter_name' className='form-control' type='text'  onChange={(e) => this.handleChange(e, index)} value={this.state.twitter_name} />
                      {this.validator.message('Twitter', this.state.twitter_name, 'required', { className: 'text-danger error-msg' })}
                    </div>
                  </React.Fragment>
                )
              } */}
                              {/* As customer request there is one social media link that is on overview page for all categories */}
                              {(item.cid == 8) &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> When (Date) <span class="astrick">*</span></label>
                                      <input name='when' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.when} />
                                      {this.validator.message('When', item.when, 'required|alpha_num_space', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label> Where <span class="astrick">*</span></label>
                                      <input name='where' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.where} />
                                      {this.validator.message('Where', item.where, 'required', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label> Registration Info (Email ID) <span class="astrick">*</span></label>
                                      <input name='registration_info' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.registration_info} />
                                      {this.validator.message('Registration Info ', item.registration_info, 'required', { className: 'text-danger error-msg' })}
                                    </div>
                                  </React.Fragment>
                                )
                              }
                              {(item.cid == 7) &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label>Hall Capacity</label>
                                      <input name='hall_capacity' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.hall_capacity} />
                                      {this.validator.message('Hall Capacity', item.hall_capacity, 'alpha_num_space', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label>Dinning Hall Capacity</label>
                                      <input name='dinning_hall_capacity' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.dinning_hall_capacity} />
                                      {this.validator.message('Dinning Hall Capacity', item.dinning_hall_capacity, 'alpha_num_space', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label>Car Parking </label>
                                      <input name='car_parking' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.car_parking} />
                                      {this.validator.message('Car Parking', item.car_parking, 'alpha_num_space', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label>Two Wheeler Parking</label>
                                      <input name='two_parking' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.two_parking} />
                                      {this.validator.message('Two Wheeler Parking', item.two_parking, 'alpha_num_space', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label>Operating Hours </label>
                                      <input name='operating_hrs' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.operating_hrs} />
                                      {this.validator.message('Operating Hours', item.operating_hrs, 'alpha_num_space', { className: 'text-danger error-msg' })}
                                    </div>
                                    <div class="form-group col-md-4">
                                      <label>Type of Food Served <span class="astrick">*</span></label>
                                      <input name='food' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.food} />
                                      {this.validator.message('Food ', item.food, 'required|alpha_num_space', { className: 'text-danger error-msg' })}
                                    </div>
                                  </React.Fragment>
                                )
                              }
                              {(item.cid == 7 || item.cid == 121) &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> Mode of Payment <span class="astrick">*</span></label>
                                      <select
                                        className='form-control selectpicker'
                                        name='payment_type'
                                        value={item.payment_type}
                                        title='Select Payment'
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        {dropdown.payment_type && dropdown.payment_type.map((val, i) => {
                                          return (
                                            <option value={val.id} key={i} >
                                              {val.payment_name}
                                            </option>
                                          )
                                        })}
                                      </select>
                                      {this.validator.message('Mode of Payment', item.payment_type, 'required', { className: 'text-danger error-msg' })}

                                    </div>
                                  </React.Fragment>
                                )
                              }
                              {(item.cid == 1 &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> Is Scholarship Avail <span class="astrick">*</span></label>
                                      <select
                                        className='form-control selectpicker'
                                        name='has_scholarship'
                                        value={item.has_scholarship}
                                        title='Select'
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        <option value='0'>NA</option>
                                        <option value='1'>Yes</option>
                                        <option value='2'>No</option>
                                      </select>
                                      {this.validator.message('Scholarship', item.has_scholarship, 'required', { className: 'text-danger error-msg' })}

                                    </div>
                                    {(item.has_scholarship == 1 && (
                                      <div class="form-group col-md-4">
                                        <label> Scholarship Description <span class="astrick">*</span></label>
                                        <textarea className="form-control" name='scholarship_desc' onChange={(e) => this.handleChange(e, index)} value={item.scholarship_desc}></textarea>
                                        {this.validator.message('Scholarship Descrption', item.scholarship_desc, 'required', { className: 'text-danger error-msg' })}
                                      </div>
                                    ))}
                                  </React.Fragment>
                                )
                              )}
                              {((item.cid == 4 || item.cid == 2 || item.cid == 6 || item.cid == 8) &&
                                (
                                  <React.Fragment>
                                    <div class="form-group col-md-4">
                                      <label> Is Free Trial Class Avail <span class="astrick">*</span></label>
                                      <select
                                        className='form-control selectpicker'
                                        name='has_trail'
                                        value={item.has_trail}
                                        title='Select'
                                        onChange={(e) => this.handleSelect(e, index)}>
                                        <option value='0'>NA</option>
                                        <option value='1'>Yes</option>
                                        <option value='2'>No</option>
                                      </select>
                                      {this.validator.message('Free Trail', item.has_trail, 'required', { className: 'text-danger error-msg' })}

                                    </div>
                                    {((item.has_trail == 1 && item.cid != 2) && (
                                      <div class="form-group col-md-4">
                                        <label> Free Trail Description <span class="astrick">*</span></label>
                                        <textarea className="form-control" name='trail_desc' onChange={(e) => this.handleChange(e, index)} value={item.trail_desc}></textarea>
                                        {this.validator.message('Free Trail Descrption', item.trail_desc, 'required', { className: 'text-danger error-msg' })}
                                      </div>
                                    ))}
                                  </React.Fragment>
                                )
                              )}
                              <div class="form-group col-md-4">
                                <label>Website</label>
                                <input name='website' className='form-control' type='text' onChange={(e) => this.handleChange(e, index)} value={item.website} />
                                {this.validator.message('Website', item.website, 'checkUrl', { className: 'text-danger error-msg' })}
                              </div>
                              
                            <div class="col-md-12 col-xs-12 btn-bdr text-right pad-hor-no mar-btm">
                            <button type='submit' id="btnSubmit"
                            className="btn btn-primary btn-sm">
                            Submit Key info
                            </button>
                            </div>

                            </div>



                          )}
                      </div>
                    </CardBody>
                  </Collapse>
                </Card>
                 </form>                           
                </div>
              )
            })}
            
           
            
         
        </div>

        </div>
        <NotificationContainer/>
      </React.Fragment >

    );
  }
  submitForm = (e, i) => {
    e.preventDefault();
    let page_data = this.state.page_data;
    this.setState({
      btnDisabled: true
    })
    
    let THIS = this;
    console.log('**', this.validator.getErrorMessages())
    if (this.validator.allValid()) {
     
      const { user_type, login_id, set_id } = this.state.user_data;
      let request = JSON.stringify({
        user_type: user_type,
        login_id: login_id,
        sid: set_id,
        data: page_data[i],
        active_status: this.state.active_status,
        url: 'updateKeyInfo'
      });
      partnerApi(request).then(res => {
        
     
        if (res.status === 1) {
          //toastr = window.toastr.success;
          NotificationManager.success(res.message);

          this.setState({
            btnDisabled: false
          })

        } else {
          //toastr = window.toastr.error;
          NotificationManager.error(res.message);
          this.setState({
            btnDisabled: false
          })
        }
         
      });
    } else {
      this.validator.showMessages();
      NotificationManager.error("There are a few input fields blank, Please expand and fill the blank");
      this.forceUpdate();
      setTimeout(function () {
        THIS.setState({
          checking: false
        })
      }, 500)
    }
  };
  async getDropData() {
    let board_of_education = [], type_institute = [], school_type = [], education_system = [],
      grades = [], timings = [], facilities = [], playarea_type = [], learning_option = [], getTuitionCls = [],
      learning_type = [], class_frequency = [], camp_type = [], payment_type = [], cons_service = [];
    let res1 = await FetchCall.getSchoolListDatas('curriculum');
    if (res1.status === 1) {
      board_of_education = res1.results;
    }
    let res2 = await FetchCall.getSchoolListDatas('type');
    if (res2.status === 1) {
      type_institute = res2.results;
    }
    let res3 = await FetchCall.getSchoolListDatas('school_type');
    if (res3.status === 1) {
      school_type = res3.results;
    }
    let res4 = await FetchCall.getSchoolListDatas('education_system');
    if (res4.status === 1) {
      education_system = res4.results;
    }
    let res5 = await FetchCall.getSchoolListDatas('grade');
    if (res5.status === 1) {
      grades = res5.results;
    }
    let res6 = await FetchCall.getSchoolListDatas('timing');
    if (res6.status === 1) {
      timings = res6.results;
    }
    let res7 = await FetchCall.getSchoolListDatas('facilities');
    if (res7.status === 1) {
      facilities = res7.results;
    }
    let res8 = await FetchCall.getSchoolListDatas('play_age');
    if (res8.status === 1) {
      playarea_type = res8.results;
    }
    let res9 = await FetchCall.getSchoolListDatas('std_ratio');
    if (res9.status === 1) {
      learning_option = res9.results;
    }
    let res10 = await FetchCall.getSchoolListDatas('tution_type');
    if (res10.status === 1) {
      learning_type = res10.results;
    }
    let res11 = await FetchCall.getSchoolListDatas('class_frequency');
    if (res11.status === 1) {
      class_frequency = res11.results;
    }
    let res12 = await FetchCall.getSchoolListDatas('age_group');
    if (res12.status === 1) {
      camp_type = res12.results;
    }
    let res13 = await FetchCall.getSchoolListDatas('payment_type');
    if (res13.status === 1) {
      payment_type = res13.results;
    }
    let res14 = await FetchCall.getSchoolListDatas('services');
    if (res14.status === 1) {
      cons_service = res14.results;
    }
    let res15 = await FetchCall.getSchoolListDatas('tuition_cls');
    if (res15.status === 1) {
      getTuitionCls = res15.results;
    }
    this.setState({
      dropdown: {
        board_of_education: board_of_education,
        type_institute: type_institute,
        school_type: school_type,
        education_system: education_system,
        grades: grades,
        timings: timings,
        facilities: facilities,
        playarea_type: playarea_type,
        learning_option: learning_option,
        learning_type: learning_type,
        class_frequency: class_frequency,
        camp_type: camp_type,
        payment_type: payment_type,
        cons_service: cons_service,
        getTuitionCls: getTuitionCls
      }
    });
  }
}

export default Keyinfo;



// WEBPACK FOOTER //
// ./src/components/bewise/partners/other_info/keyinfo_otherV3.jsx